import 'bootstrap';

/**
 * Import SweetAlert2 and Toastr for beautiful alerts and notifications
 */
import Swal from 'sweetalert2';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

window.Swal = Swal;
window.toastr = toastr;

// Configure toastr defaults
toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};

// Create beautiful helper functions for common dialogs
window.showAlert = function(title, text, icon = 'info') {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: 'OK',
    confirmButtonColor: '#c54141'
  });
};

window.showConfirm = function(title, text, confirmText = 'Yes', cancelText = 'No') {
  return Swal.fire({
    title: title,
    text: text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#c54141',
    cancelButtonColor: '#6c757d',
    confirmButtonText: confirmText,
    cancelButtonText: cancelText
  });
};

window.showPrompt = function(title, text, inputPlaceholder = '', inputValue = '') {
  return Swal.fire({
    title: title,
    text: text,
    input: 'textarea',
    inputPlaceholder: inputPlaceholder,
    inputValue: inputValue,
    showCancelButton: true,
    confirmButtonColor: '#c54141',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Submit',
    cancelButtonText: 'Cancel',
    inputValidator: null // Allow empty input
  });
};

window.showSuccess = function(message) {
  return toastr.success(message);
};

window.showError = function(message) {
  return toastr.error(message);
};

window.showWarning = function(message) {
  return toastr.warning(message);
};

window.showInfo = function(message) {
  return toastr.info(message);
};

/**
 * Update ARM COINS balance shown in the site header / sidebar menu.
 */
window.updateHeaderArmCoinBalance = function (balance) {
  const numericBalance = Number(balance || 0);
  const formatted = numericBalance.toLocaleString();

  document.querySelectorAll('.header-arm-coin-wallet__balance, .sidebar-wallet-balance').forEach((element) => {
    element.textContent = formatted;
  });

  document.querySelectorAll('.header-arm-coin-wallet').forEach((link) => {
    const coinLabel = link.dataset.walletCoinLabel || link.querySelector('.header-arm-coin-wallet__label')?.textContent?.trim() || '';
    const prefix = link.dataset.walletAriaPrefix || link.getAttribute('aria-label')?.split(':')[0]?.trim() || '';

    if (prefix && coinLabel) {
      link.setAttribute('aria-label', `${prefix}: ${formatted} ${coinLabel}`);
    }
  });

  window.dispatchEvent(new CustomEvent('arm-coin-balance:updated', {
    detail: { balance: numericBalance },
  }));
};

/**
 * Define El object for legacy compatibility with error messages
 */
window.El = {
  Message: {
    error: function(message) {
      return toastr.error(message);
    },
    success: function(message) {
      return toastr.success(message);
    },
    warning: function(message) {
      return toastr.warning(message);
    },
    info: function(message) {
      return toastr.info(message);
    }
  }
};

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const isProdEnv = (process.env.MIX_APP_ENV || process.env.NODE_ENV) === 'production';

// Get Pusher key and cluster - check both process.env and window (for runtime)
const pusherKey = window.MIX_PUSHER_APP_KEY || process.env.MIX_PUSHER_APP_KEY;
const pusherCluster = window.MIX_PUSHER_APP_CLUSTER || process.env.MIX_PUSHER_APP_CLUSTER || 'mt1';

// Initialize Echo for the main site so chat scripts can rely on it
if (pusherKey && pusherKey !== 'undefined') {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: pusherKey,
    cluster: pusherCluster,
    forceTLS: true,
    disableStats: true,
    authEndpoint: '/broadcasting/auth',
    auth: {
      headers: {
        'X-CSRF-TOKEN': csrfToken,
      }
    }
  });

  if (!isProdEnv) {
    console.log('✅ Echo initialized in main bootstrap with channel chat.*');
  }

  if (window.chatEchoReadyCallbacks?.length) {
    window.chatEchoReadyCallbacks.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('Error running chat Echo callback', error);
      }
    });
    window.chatEchoReadyCallbacks = [];
  }
} else {
  if (!isProdEnv) {
    console.warn('⚠️ Skipped Echo initialization because Pusher key is not available yet.');
  }
}
